'use strict';

/**
 * QA contents accordion
 */
module.exports = function () {
    $(window).on('load', function() {
        $('.m-qa').each(function() {
            const H = $(this).attr('data-cnt-height');
            const $cnt = $(this).find('.m-qa_cnt');
            $cnt.each(function() {
                const _this = $(this);
                const cntH = _this.innerHeight();
                const $acc = _this.closest('dd').find('.m-qa_acc');
                if (cntH > H) {
                    _this.attr('aria-hidden', 'true').css('height', H);
                    $acc.show();
                } else {
                    _this.attr('aria-hidden', 'false').css('height', 'auto');
                    $acc.hide();
                }

                $acc.on('click', function(e) {
                    const $more = $(this).find('.m-qa_more');
                    const $close = $(this).find('.m-qa_close');
                    e.preventDefault();
                    if (_this.attr('aria-hidden') === 'true') {
                        _this.attr('aria-hidden', 'false').css('height', 'auto');
                        $more.hide();
                        $close.show();
                    } else {
                        _this.attr('aria-hidden', 'true').css('height', H);
                        $more.show();
                        $close.hide();
                    }
                });
            });
        });
    });
};

